import Landing from "./Landing";
import Features from "./Features";
import Create from "./Create";
import Products from "./Products";

const Home = () => {
  return (
    <main>
      <Landing />
      <Features />
      {/* <Create /> */}
      <Products />
    </main>
  );
};

export default Home;
